import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-report.dto';
export * from './dtos/report-list.dto';
export * from './dtos/report-record.dto';
export * from './dtos/report-search.dto';
export * from './dtos/report-variable.dto';
export * from './dtos/reports-stats.dto';
export * from './dtos/update-report.dto';

export * from './enums/report-action.enum';
export * from './enums/report-type.enum';
export * from './enums/report-status.enum';
export * from './enums/report-schedule-type.enum';
export * from './enums/report-variable-type.enum';

export * from './functions/report-status-to-color.function';

export * from './types/report-data';
export * from './types/reports-filters';

export * from './validators/schemas/create-report.schema';
export * from './validators/schemas/update-report.schema';

export const reportValidators = { canCreateOrUpdate, canPerformAction };
